import axiosInstance from "../../axiosInstanceSetup";
import { LOAD_API_DATA, SET_API_DATA, SET_FORM_OPTION } from "./accessManagement.type";

export const getDataDomainSubdomain = () => {
    return async (dispatch, getState, { endpoint }) => {
      dispatch({
        type: LOAD_API_DATA,
        payload: { apiField: "domainSubDomain" },
      });
      axiosInstance.get(`${endpoint}${process.env.REACT_APP_DOMAIN_SUBDOMAIN}`)
        .then(response => {
          // Handle success
          if (response.data.status === "success") {
            dispatch({
              type: SET_API_DATA,
              payload: {
                apiField: "domainSubDomain",
                data: response.data.data,
                status: "success",
              },
            })
            dispatch({
              type: SET_FORM_OPTION,
              payload: {
                formField: "domainSubDomainForm",
                data: response.data.data
              }
            })
          }
          // let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
          // tempArray.push("fetched Domain SubDomain successfully")
          // sessionStorage.setItem('bellNotification', JSON.stringify(tempArray));
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
    };
  };